<div class="host-upload-voucher">
  <div class="list">
    <div
      class="item"
      *ngFor="let image of listOfImage">
      <img
        class="voucher"
        hostPlaceholder
        src="/assets/status/no-img.png"
        [delaySrc]="image.url"
        (click)="onClickImage(image.url)"
        alt>
      <img
        src="/assets/icon/upload-delete.png"
        alt
        class="delete"
        (click)="onDeleteImage(image)">
    </div>
    <nz-upload
      class="item"
      nzAction="/api/upload/image"
      [nzShowUploadList]="false"
      [nzBeforeUpload]="beforeUpload"
      [nzAccept]="'image'"
      (nzChange)="handleChange($event)">
      <div class="upload-btn">
        <i
          nz-icon
          nzType="plus"
          nzTheme="outline"></i>
      </div>
    </nz-upload>
  </div>
</div>
